import { useNavigate } from "react-router";
import { useI18n } from "@wato/i18n/react";
import { Button } from "@wato/ui";

/** OWN-377 B4: Google glyph — a plain letter in `currentColor` (no multi-colour brand asset). */
function GoogleGlyph() {
  return (
    <span aria-hidden="true" className="text-base font-bold leading-none">
      G
    </span>
  );
}

/** Message-bubble glyph (stroke, `currentColor`) for the WhatsApp sign-in. */
function WhatsAppGlyph() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </svg>
  );
}

/** Google + WhatsApp sign-in, identical on the login and signup pages. */
export function SocialAuthButtons() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <>
      <p className="text-center text-xs text-fg-subtle">{t("dashboard.auth.or")}</p>
      <Button
        variant="secondary"
        fullWidth
        data-testid="auth-google"
        onClick={() => window.location.assign("/v1/auth/google/start")}
      >
        <span className="flex items-center justify-center gap-2">
          <GoogleGlyph />
          {t("dashboard.auth.login.google")}
        </span>
      </Button>
      <Button
        variant="secondary"
        fullWidth
        data-testid="auth-whatsapp"
        onClick={() => void navigate("/login/phone")}
      >
        <span className="flex items-center justify-center gap-2">
          <WhatsAppGlyph />
          {t("dashboard.auth.login.whatsapp")}
        </span>
      </Button>
    </>
  );
}
